import React from 'react';
import './cardVavaka.scss';
import logo from "../../../assets/imgs/logo-removebg.png"
import { Link } from 'react-router-dom';
import { baseUrl } from '../../../config/config';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';

const CardVavaka = ({vavakas, handleDelete}) => {

  return (
    <div className="cardVavaka">
      <img src={logo} alt="logo" />
      <p className='lohateny'>{vavakas.lohateny}</p>
      <p className='vavaka'>{vavakas?.vavaka}</p>
      <div className="audio-container">
        {vavakas.audio && (
          <div className="audio-container">
            <audio controls className="audio">
              <source src={`${baseUrl}/vavaka/stream-audio/${vavakas.id}`} type="audio/mp3" />
            </audio>
          </div>
        )}
      </div>

      <div className='buttonContainer' >
        <Link to={`/vavaka/updateVavaka/${vavakas.id}`}>
          <button><FaEdit /></button>
        </Link>

        <button className='btn' onClick={handleDelete}><MdDelete /></button>
      </div>
    </div>
  )
}

export default CardVavaka